import { render } from "./PerkiraanMedaliPage.vue?vue&type=template&id=221c4c24&scoped=true"
import script from "./PerkiraanMedaliPage.vue?vue&type=script&lang=js"
export * from "./PerkiraanMedaliPage.vue?vue&type=script&lang=js"

import "./PerkiraanMedaliPage.vue?vue&type=style&index=0&id=221c4c24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221c4c24"]])

export default __exports__